import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { AllStakeholderGrid, AllStakeholderRow, Stakeholder } from '../models/stakeholder';

@Injectable({
    providedIn: 'root'
})
export class StakeholderService {
    constructor(private httpService: JsonHttpService) {
    }

    getStakeholders(): Promise<Stakeholder[]> {
        return this.httpService.get('/api/errorhandling/stakeholders/get-stakeholders').toPromise();
    }


    getAllStakeholders(): Promise<AllStakeholderGrid> {
        return this.httpService.get('/api/errorhandling/stakeholders/get-all-stakeholders').toPromise();
    }

    saveStakeholder(stakeholderRow: AllStakeholderRow): Promise<AllStakeholderRow> {
        return this.httpService.post('/api/errorhandling/stakeholders/save-stakeholder', stakeholderRow).toPromise();
    }

    deleteStakeholder(stakeholderRow: AllStakeholderRow): Promise<AllStakeholderRow> {
        const options = { params: new HttpParams().set('stakeholderId', `${stakeholderRow.StakeholderId}`) };
        return this.httpService.post('/api/errorhandling/stakeholders/delete-stakeholder',null, options).toPromise();
    }
}
